// extracted by mini-css-extract-plugin
export default {"card":"N2-z"};